import * as React from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";

export default function TransitionAlerts(props) {
  return (
    <Box sx={{ width: "100%" }}>
      <Collapse in={props.open}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={props.closeHandler}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: props.mb ? props.mb : 2 }}
          severity={props.severity}
        >
          {props.message}
        </Alert>
      </Collapse>
    </Box>
  );
}
